// extracted by mini-css-extract-plugin
module.exports = {"maxContainer":"maxContainer_maxContainer__Ajj3E"};